import React, { useEffect } from 'react'
import { Library } from './page';

export function LibraryMain() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='w-full pt-[60px] bg-white'>
      {/* Hero / Banner Section - Reduced height */}
      <div className='h-[20vh] md:h-[25vh] flex items-end px-6 md:px-16 relative overflow-hidden'>
        {/* Background Image */}
        <img
          className='h-full w-full absolute object-cover inset-0 z-0 transform scale-105'
          src="/assets/library.jpg"
          alt="Library Background"
          loading="lazy"
        />

        {/* Overlay */}
        <div className='absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent z-40'></div>

        {/* Header Content - Slightly smaller text */}
        <div className='relative z-50 flex flex-col pb-8 md:pb-10 max-w-4xl'>
          <h1 className='text-4xl md:text-5xl font-AndoraModernSerif font-black uppercase text-[#e67e22] tracking-wide drop-shadow-lg mb-1'>
            LIBRARY
          </h1>
          <p className='text-gray-200 text-sm md:text-base font-light tracking-wide opacity-90'>
            Our complete Playlists and Books Here...
          </p>
        </div>
      </div>

      {/* Quick Navigation Buttons */}
      <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 py-8 bg-white border-b border-gray-50 px-4">
        {[
          { label: 'Videos', id: 'videos-section' },
          { label: 'Books', id: 'books-section' },
          { label: 'Magazines', id: 'magazines-section' }
        ].map((btn) => (
          <button
            key={btn.id}
            onClick={() => document.getElementById(btn.id)?.scrollIntoView({ behavior: 'smooth' })}
            className="px-6 md:px-8 py-2.5 bg-[#fafafa] text-gray-400 rounded-full font-medium text-[11px] uppercase tracking-[0.15em] border border-gray-100 hover:bg-white hover:text-pumpkinToast-600 hover:border-pumpkinToast-200 hover:shadow-lg hover:shadow-orange-50 transition-all active:scale-95"
          >
            {btn.label}
          </button>
        ))}
      </div>

      {/* Main Content Sections */}
      <Library />
    </div>
  )
}
